import React from 'react';
import { Box, Title, Text, Group, useMantineTheme } from '@mantine/core';

export default function Module({
  title,
  subtitle,
  children,
  icon: IconComponent,
  titleExtra,
  contentMt = 'xs',
}) {
  const theme = useMantineTheme();
  const palette = theme.colors[theme.primaryColor] || theme.colors.grape;
  const hasHeader = title || subtitle;

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      {hasHeader && (
        <Box style={{ flexShrink: 0, paddingBottom: 4 }}>
          <Group justify="space-between" align="center" wrap="nowrap" gap="sm">
            <Group gap="sm" wrap="nowrap" align="center" style={{ flex: 1, minWidth: 0 }}>
              {IconComponent && (
                <IconComponent size={28} color={palette[7]} stroke={1.5} style={{ flexShrink: 0 }} />
              )}
              {title && (
                <Title order={2} style={{ lineHeight: 1.2 }}>
                  {title}
                </Title>
              )}
              {titleExtra ? <Box style={{ flexShrink: 0 }}>{titleExtra}</Box> : null}
            </Group>
            {subtitle ? (
              <Text
                c="dimmed"
                size="sm"
                lineClamp={1}
                style={{ flexShrink: 1, textAlign: 'right', maxWidth: '45%' }}
              >
                {subtitle}
              </Text>
            ) : null}
          </Group>
        </Box>
      )}
      <Box
        mt={hasHeader ? contentMt : 0}
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
